import { useAuth } from '../../components/AuthProvider';
import PropertiesPage from '../../containers/PropertiesPage';
import { ZRAMPropertiesPage } from '../../containers/ZRAMPropertiesPage';

const PropertiesRoute = () => {
  const { user } = useAuth();

  if (user?.isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesRoute;
